import React from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";

export default function PaymentSuccess() {
  const navigate = useNavigate();

  const supportNumber = "8050065924";
  const telLink = `tel:+91${supportNumber}`;

  return (
    <div className="min-h-screen w-full bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-slate-100 flex items-center justify-center px-4 py-10">
      {/* soft glows */}
      <div className="pointer-events-none fixed inset-0">
        <div className="absolute -top-24 left-10 h-72 w-72 rounded-full bg-emerald-500/15 blur-3xl" />
        <div className="absolute -top-24 right-10 h-72 w-72 rounded-full bg-blue-500/15 blur-3xl" />
        <div className="absolute bottom-0 left-1/2 h-80 w-80 -translate-x-1/2 rounded-full bg-purple-500/10 blur-3xl" />
      </div>

      <div className="relative w-full max-w-4xl rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-[0_20px_70px_rgba(0,0,0,0.55)] overflow-hidden">
        {/* top accent */}
        <div className="h-1 w-full bg-gradient-to-r from-emerald-500 via-sky-500 to-purple-500" />

        <div className="p-6 sm:p-10">
          {/* header */}
          <div className="flex items-start gap-4">
            <div className="relative">
              <div className="absolute inset-0 rounded-full bg-emerald-400/20 blur-xl" />
              <div className="relative grid h-14 w-14 place-items-center rounded-2xl bg-emerald-500/15 border border-emerald-400/20">
                <CheckCircle className="h-8 w-8 text-emerald-400" />
              </div>
            </div>

            <div>
              <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">
                Payment Successful
              </h1>
              <p className="mt-2 text-sm sm:text-base text-slate-300 leading-relaxed">
                Thank you! Your payment has been received and your booking/order
                is confirmed.
              </p>

              <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-emerald-400/20 bg-emerald-500/10 px-3 py-1 text-xs sm:text-sm text-emerald-200">
                <span className="h-2 w-2 rounded-full bg-emerald-400" />
                Confirmed
              </div>
            </div>
          </div>

          {/* Company & Support */}
          <div className="mt-8 rounded-2xl border border-white/10 bg-white/5 p-5 text-center">
            <p className="text-sm sm:text-base font-semibold text-slate-100">
              Novus Health Labs
            </p>
            <p className="mt-1 text-xs sm:text-sm text-slate-400">
              Need assistance? Contact our support team
            </p>
            <a
              href={telLink}
              className="mt-3 inline-block text-lg font-semibold text-emerald-400 hover:text-emerald-300 transition"
            >
              +91 {supportNumber}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
